import React from 'react'

const Profile = () => {
    return (
            <div className="mainside">
        <div className="container">
        <div>
            Profile
        </div>
        </div>
        </div>
    )
}

export default Profile
